import { Injectable } from '@angular/core';

import * as CryptoJS from 'crypto-js';

@Injectable({
	providedIn: 'root',
})
export class DecrypttextService {
	constructor() {}
	//The set method is use for encrypt the value.
	set(value: string, key: string) {
		var encrypted = CryptoJS.AES.encrypt(value, key, {
			keySize: 25,
			iv: CryptoJS.enc.Utf8.parse(key),
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7,
		}).toString();

		return encrypted;
	}

	//The get method is use for decrypt the value.
	get(value: string, key: string) {
		var decrypted = CryptoJS.AES.decrypt(value, key, {
			keySize: 25,
			iv: CryptoJS.enc.Utf8.parse(key),
			mode: CryptoJS.mode.ECB,
			padding: CryptoJS.pad.Pkcs7,
		}).toString(CryptoJS.enc.Utf8);

		return decrypted;
	}
}
